export function getUTCDateFromISTDateString(date) {
  const localDate = new Date(date);
  localDate.setHours(0, 0, 0, 0);

  return new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
}